

import { ChangeDetectionStrategy, Component, Input, OnChanges, TemplateRef, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';

import { MwcSafeAny } from 'mwc/core/types';

@Component({
  selector: 'mwc-option-group',
  exportAs: 'mwcOptionGroup',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: ` <ng-content></ng-content> `
})
export class MwcOptionGroupComponent implements OnChanges {
  @Input() mwcLabel: string | number | TemplateRef<MwcSafeAny> | null = null;
  changes = new Subject<void>();
  ngOnChanges(): void {
    this.changes.next();
  }
}
